import { IIndicatorData } from "./iindicator-data-strategy";
import { IndicatorData } from "./indicator-data";

export class CompanySubsidiaryBalanceIndicatorData implements IIndicatorData {
  private readonly name: string = "SubsidiaryMonthlyBalance";

  constructor(private readonly items: IndicatorData[]) {}

  getName(): string {
    return this.name;
  }

  getMonths(): Array<string> {
    const months = new Array<string>();

    this.items.forEach((item) => {
      months.push(item.getKey());
    });

    return months;
  }

  private getValues(): Array<IndicatorData> {
    const values: any[] = [];
    const dataValues: IndicatorData[] = [];
    this.items.forEach((item) => {
      values.push(item.getValue());
    });
    values.forEach((item) => {
      dataValues.push(item);
    });
    return values;
  }

  getCompanyName(): string {
    const indicatorData = new Array<any>();
    const values = this.getValues();
    values.forEach((value) => {
      indicatorData.push(value);
    });
    if (indicatorData[0].length > 0) {
      return indicatorData[0][0][0].getValue();
    }
    return null;
  }

  getSubsidiaryNames(): Array<string> {
    const indicatorData = new Array<any>();
    const subsidiaryNames = new Array<string>();

    const values = this.getValues();

    values.forEach((value) => {
      indicatorData.push(value);
    });

    indicatorData.forEach((value) => {
      value.forEach((item) => {
        if (subsidiaryNames.indexOf(item[1].getValue()) < 0) {
          subsidiaryNames.push(item[1].getValue());
        }
      });
    });

    return subsidiaryNames;
  }

  getSubsidiaryValues(companyName: string): Array<number> {
    const indicatorData = new Array<any>();
    const subsidiaryValues = new Array<number>();

    const values = this.getValues();

    values.forEach((value) => {
      indicatorData.push(value);
    });

    indicatorData.forEach((value) => {
      value.forEach((item) => {
        if (item[1].getValue() === companyName) {
          subsidiaryValues.push(item[2].getValue());
        }
      });
    });

    return subsidiaryValues;
  }
}
